import { Component, Input, Output, ViewEncapsulation } from "@angular/core";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { ManageAppDeviceTypesComponent } from "./modals/manage-app-device-types/manage-app-device-types.component";
import { SharedDataService } from "src/app/services/shared-data/shared-data.service";
import { Subject, Subscription } from "rxjs";

@Component({
  selector: "app-device-types",
  templateUrl: "./app-device-types.component.html",
  styleUrls: ["./app-device-types.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppDeviceTypesComponent {
  @Input() data: any;
  @Input() opts: any;
  @Input() clientSettings: any;
  @Output() outgoing: any = new Subject();

  public tableLoading: boolean = false;
  public errorRetrievingMsg: string = "Error retrieving device types";
  public tableData: any;
  public tableDataType: {
    singular: string;
    plural: string;
  } = {
    singular: "device type",
    plural: "device types",
  };
  public tableColumns: {
    type: string;
    parent?: string;
    target: string;
    actions?: any;
  }[] = [
    {
      type: "actions",
      target: "actions",
      actions: [
        {
          label: "Edit",
          icon: "faPencilAlt",
          type: "edit",
          onClick: (row) => {
            this.manageDeviceType("edit", row);
          },
        },
        {
          label: "Delete",
          icon: "faTrashAlt",
          type: "delete",
          onClick: (row) => {
            this.manageDeviceType("delete", row);
          },
        },
      ],
    },
    {
      type: "keyValue",
      target: "label",
    },
  ];

  //head elements
  public headElements = ["action", "Label"];

  //sorting
  sort_elements = [
    {
      type: "none",
      head: "actions",
    },
    {
      type: "string",
      head: "label",
    },
  ];
  sort = {
    direction: "asc",
    head: "label",
    type: "string",
  };

  public sortBy = "label";
  public sortOrder = "asc";

  //filtering
  filter_elements = [];
  public filterText = {
    label: "",
  };
  public compoundFilterParams: {};

  //modal related
  private modalOptions = {
    backdrop: "static",
    keyboard: false,
    focus: true,
    show: false,
    ignoreBackdropClick: true,
    class: "modal-dialog-centered",
    containerClass: "",
    animated: true,
    data: {},
  };
  public deviceTypeFrame: MDBModalRef;

  //subscriptions
  private shareDataSubscription: Subscription;

  constructor(
    private modalService: MDBModalService,
    private _sharedDataService: SharedDataService
  ) {}

  ngOnInit() {
    this.configureFilters();
    this.tableData = this.data.appDevices;

    this.shareDataSubscription =
      this._sharedDataService.sharedDataComm$.subscribe((incoming: any) => {
        if (incoming.type === "buttonAction") {
          if (
            incoming.data.buttonAction !== undefined &&
            incoming.data.buttonAction === "add_device_type"
          ) {
            this.manageDeviceType("add");
          }
        }
      });

    //also let menu know that we're done loading
    let toSend = {
      type: "pageLoaded",
      data: {
        pageLoaded: true,
      },
    };

    this._sharedDataService.sendSharedData(toSend);
  }

  private configureFilters() {
    this.filter_elements = [
      {
        filter: false,
        type: "close_filters",
        target: "actions",
      },
      {
        filter: true,
        type: "text",
        target: "label",
      },
    ];

    this.compoundFilterParams = {
      label: {
        text: this.filterText.label,
        type: "text",
      },
    };
  }

  public manageDeviceType(action, deviceType?) {
    this.modalOptions.containerClass = "";
    this.modalOptions = {
      ...this.modalOptions,
      containerClass:
        action === "delete"
          ? "remove-class-container"
          : "schedule-class-container",
      class:
        action !== "delete"
          ? this.modalOptions.class +
            " modal-full-height modal-right manage-event-display"
          : "",
    };

    this.modalOptions.data = {
      teamID: this.data.teamID,
      type: "device type",
      targetDeviceType: deviceType,
      action: action,
      data: this.data,
    };

    this.deviceTypeFrame = this.modalService.show(
      ManageAppDeviceTypesComponent,
      this.modalOptions
    );

    this.deviceTypeFrame.content.outgoing.subscribe((result: any) => {
      if (action === "add") {
        this.data.appDevices.push(result.app_device);
      } else if (action === "edit") {
        this.data.appDevices = this.data.appDevices.map((deviceType) => {
          if (deviceType.id === result.app_device.id) {
            deviceType = result.app_device;
          }
          return deviceType;
        });
      } else if (action === "delete") {
        this.data.appDevices = this.data.appDevices.filter((deviceType) => {
          return deviceType.id !== result.app_device.id;
        });
      }

      this.tableData = this.data.appDevices.filter((deviceType) => {
        return deviceType;
      });

      this.outgoing.next({
        type: "updateDeviceTypes",
        data: {
          appDevices: this.data.appDevices,
        },
      });
    });
  }
}
